/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Match_Help_RegexInputs */



/**
* | output |
* | --- |
* | "Matches using regular expression patterns for complex rules" |
*
* @param {Compliance_Template_Match_Help_RegexInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_match_help_regex = /** @type {((inputs?: Compliance_Template_Match_Help_RegexInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Match_Help_RegexInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passt unter Verwendung von regulären Ausdrücken für komplexe Regeln")
	return /** @type {LocalizedString} */ ("Matches using regular expression patterns for complex rules")
});